import { normalizeRoleSlug } from "../../../public/utils/roleAccess";
import {
  INWARD_OUTWARD_REGISTER_SUBMODULE_SLUG,
  INWARDS_REGISTER_SUBMODULE_SLUG,
  OUTWARDS_REGISTER_SUBMODULE_SLUG,
} from "./inwardOutwardPermissionSlugs";

function permRow(permMap, slug) {
  const row = permMap?.[slug];
  return row && typeof row === "object" ? row : {};
}

function registerStylePerms(row) {
  const canView = Boolean(row.view);
  const canCreate = Boolean(row.create);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  return {
    canView: canView || canCreate,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: false,
    canDeleteMasters: false,
    canExport: canView || canCreate,
    isAdmin: false,
  };
}

function controlStylePerms(permMap) {
  const row = permRow(permMap, INWARD_OUTWARD_REGISTER_SUBMODULE_SLUG);
  const inwardsRow = permRow(permMap, INWARDS_REGISTER_SUBMODULE_SLUG);
  const outwardsRow = permRow(permMap, OUTWARDS_REGISTER_SUBMODULE_SLUG);
  const canView = Boolean(row.view);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  const canCreate =
    Boolean(row.create) ||
    Boolean(inwardsRow.create) ||
    Boolean(outwardsRow.create);
  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: canView && canEdit,
    canDeleteMasters: canDelete,
    canExport: canView,
    isAdmin: canView,
  };
}

export function buildInwardOutwardPermissionsForScreen(
  permMap = {},
  _roleSlug = "",
  screenSlug = "",
) {
  const slug = normalizeRoleSlug(screenSlug);

  if (slug === INWARDS_REGISTER_SUBMODULE_SLUG) {
    return registerStylePerms(permRow(permMap, slug));
  }

  if (slug === OUTWARDS_REGISTER_SUBMODULE_SLUG) {
    return registerStylePerms(permRow(permMap, slug));
  }

  if (slug === INWARD_OUTWARD_REGISTER_SUBMODULE_SLUG) {
    return controlStylePerms(permMap);
  }

  return buildInwardOutwardPermissions(permMap);
}

export function buildInwardOutwardPermissions(permMap = {}) {
  const control = controlStylePerms(permMap);
  const inwards = registerStylePerms(permRow(permMap, INWARDS_REGISTER_SUBMODULE_SLUG));
  const outwards = registerStylePerms(permRow(permMap, OUTWARDS_REGISTER_SUBMODULE_SLUG));
  return {
    canView: control.canView || inwards.canView || outwards.canView,
    canCreate: control.canCreate || inwards.canCreate || outwards.canCreate,
    canEdit: control.canEdit || inwards.canEdit || outwards.canEdit,
    canDelete: control.canDelete,
    canManageMasters: control.canManageMasters,
    canDeleteMasters: control.canDeleteMasters,
    canExport: control.canExport || inwards.canExport || outwards.canExport,
    isAdmin: control.isAdmin,
  };
}
